import { el, setAttr, setChildren } from 'redom';

import {
  getEmailContactName
} from '../utilities';

class SenderDisplay {

  constructor() {

    this.senderNode = el('a.recipient-name.user-link');

    this.el = el('.message-sender-display-main', [
      el('label', 'From:\u00A0'),
      this.senderNode
    ]);

  }

  update(sender) {

    setAttr(this.senderNode, {
      href: `/contacts/${sender._id}`
    });

    setChildren(this.senderNode, getEmailContactName(sender));

  }

}

export default SenderDisplay;